import {
  iHeart,
  iStar,
  iBriefcase,
  iHome,
  iSun,
  iDroplet,
  iBook,
} from '@hover/icons';
import { IJobPostsBenefit } from '../interfaces/IJobPostsBenefit';

export const JOB_POSTS_BENEFITS: IJobPostsBenefit[] = [
  {
    id: 0,
    title: 'Compensation',
    body: 'Competitive salary and meaningful equity in a fast-growing company',
    icon: iStar,
  },
  {
    id: 1,
    title: 'Healthcare',
    body: 'Comprehensive medical, dental, and vision coverage for you and dependents',
    icon: iHeart,
  },
  {
    id: 2,
    title: 'Paid Time Off',
    body: 'Unlimited PTO for exempt employees and PTO accrued at 3 weeks per year for non-exempt employees',
    icon: iBriefcase,
  },
  {
    id: 3,
    title: 'Paid Family Leave',
    body: 'We support work/life balance and offer generous paid parental and new child bonding leave',
    icon: iHome,
  },
  {
    id: 4,
    title: 'Mandatory Self-Care Days',
    body: 'A day set aside each month to allow employees to recharge',
    icon: iSun,
  },
  {
    id: 5,
    title: 'Remote Wellbeing Resources',
    body: 'We provide recurring fitness classes, meditation/ mindfulness tools, virtual therapy, and family planning assistance',
    icon: iDroplet,
  },
  {
    id: 6,
    title: 'Learning',
    body: 'We encourage continued education and will help cover the cost of management training, conferences, workshops, or certifications',
    icon: iBook,
  },
];
